import { z } from "zod";

const dateValueSchema = z.union([z.string(), z.date()]);

export const plannedProductionDataApiSchema = z.object({
	id: z.string(),
	tenantId: z.string(),
	resourceId: z.string(),
	resourceType: z.string().optional(),
	title: z.string(),
	label: z.string(),
	start: dateValueSchema,
	end: dateValueSchema,
	recurrenceEndDate: dateValueSchema.nullish(),
	downtime: z.boolean(),
	excludedLocalDates: z.array(z.string()).optional(),
	color: z.string().nullish(),
	repeatSunday: z.boolean().optional(),
	repeatMonday: z.boolean().optional(),
	repeatTuesday: z.boolean().optional(),
	repeatWednesday: z.boolean().optional(),
	repeatThursday: z.boolean().optional(),
	repeatFriday: z.boolean().optional(),
	repeatSaturday: z.boolean().optional(),
	duration: z
		.object({
			milliseconds: z.number(),
		})
		.optional(),
	rrule: z
		.object({
			freq: z.number(),
			dtstart: z.string(),
			byweekday: z.array(z.string()),
		})
		.optional(),
});

export type PlannedProductionData = z.output<typeof plannedProductionDataApiSchema>;
